import GuildPresetsContract from 'decentralized/contracts/GuildPresetsContract.js';
import {getByDay, partitionBySource, fetchDaysForBlocks} from '../getSoundResults.js';
import {decryptResults} from 'decentralized/guilds/queryDecryptor.js';
import {INSTRUMENT_TYPE_TO_NAME} from 'constants/instrument-types.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import {
    NewPreset2,
    PresetTag,
    PresetSample,
    PresetInstrumentType
} from 'decentralized/EthereumEvents.js';
import {web3} from 'decentralized/web3.js';


const contract = new GuildPresetsContract();

export const getPresets = async (searchTerm) => {
     let query = new BackendQuery(contract.contractAddress)
        .from(NewPreset2)
        .select('user')
        .select('encryptedName')
        .select('contentHash')
        .select('encryptedContentKey')
        .select('publicKey')
        .select('guildId')
        .where('guildId', 0);

    let results = await decryptResults(await query.executeQuery(), 0);
    let ids = results.map(x => x.contentHash);
    let taggedResults = await getTagPresets(ids);
    let instrumentTypes = await getInstrumentTypePresets(ids);
    let combined = combineAll(results, taggedResults, instrumentTypes);
    let byDay = getByDay(filterBySearchTerms(searchTerm, combined));
    let byDayAndSource = partitionBySource(byDay, searchTerm);
    return await fetchDaysForBlocks(byDayAndSource);
};

const getTagPresets = async (hashes) => {
    let query = new BackendQuery(contract.contractAddress)
        .from(PresetTag)
        .select('contentHash')
        .select('tag')
        .whereIn('contentHash', hashes);

    let results = await query.executeQuery();
    let tags = {};
    for (let result of results) {
        if (!(result.contentHash in tags)) {
            tags[result.contentHash] = [];
        }
        tags[result.contentHash].push(result.tag);
    }

    for (let key in tags) {
        tags[key] = Array.from(new Set(tags[key]));
    }
    return tags;
};

const getInstrumentTypePresets = async (hashes) => {
    let query = new BackendQuery(contract.contractAddress)
        .from(PresetInstrumentType)
        .select('contentHash')
        .select('instrumentType')
        .whereIn('contentHash', hashes);

    return  await query.executeQuery();
};

const combineAll = (results, tags, instrumentTypes) => {
    let combined = {};
    for (let result of results) {
        combined[result.contentHash] = {
            ... result,
            tags: tags[result.contentHash] || []
        };
    }

    for (let result of instrumentTypes) {
        combined[result.contentHash] = {
            ... combined[result.contentHash],
            ... result
        };
    }

    let r = [];
    for (let result of results) {
        r.push(combined[result.contentHash]);
    }
    return r;
};

const filterBySearchTerms = (searchTerms, results) => {
    if (searchTerms === '') {
        return results;
    }

    searchTerms = searchTerms.toLowerCase();
    // see if this is an instrument type
    return results.filter(
        r => r.tags.some(tag => tag.toLowerCase().includes(searchTerms)) ||
            r.title.toLowerCase().includes(searchTerms));
};


